import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import ReportBox from './ReportBox';
import Money from '../../../common/money';
import { MoneyFitMedium } from './MoneyFit';

const PaymentMethods = ({ paymentPosCard, paymentSquireCard, paymentCash, paymentGiftCards, showGiftCards }) => (
  <ReportBox title={t('reports:dashboard.collected_by_payment_method')}>
    <div className="u-ph+">
      <div className="o-tableize o-tableize--middle">
        <div className="o-tableize__row">
          <div className="o-tableize__cell u-pb u-pt+">
            <div className="c-report-label">{t('reports:dashboard.pos_card')}</div>
          </div>
          <div className="o-tableize__cell u-pb u-pt+ u-text-right">
            <div className="c-report-stat">
              <MoneyFitMedium automationId="text:paymentPosCardAmount">{paymentPosCard}</MoneyFitMedium>
            </div>
          </div>
        </div>
        <div className="o-tableize__row">
          <div className="o-tableize__cell u-pb">
            <div className="c-report-label">{t('reports:dashboard.squire_card')}</div>
          </div>
          <div className="o-tableize__cell u-text-right u-pb-">
            <div className="c-report-stat">
              <MoneyFitMedium automationId="text:paymentSquireCardAmount">{paymentSquireCard}</MoneyFitMedium>
            </div>
          </div>
        </div>
      </div>
      <div className="c-horizontal-divider u-mt" />
      <div className="o-tableize o-tableize--middle">
        <div className="o-tableize__row">
          <div className="o-tableize__cell u-pb u-pt+">
            <div className="c-report-label">{t('reports:dashboard.cash')}</div>
          </div>
          <div className="o-tableize__cell u-pb u-pt+ u-text-right">
            <Money automationId="text:paymentCashAmount">{paymentCash}</Money>
          </div>
        </div>
        <div className="o-tableize__row" display-if={showGiftCards}>
          <div className="o-tableize__cell u-pb">
            <div className="c-report-label">{t('reports:dashboard.gift_cards')}</div>
          </div>
          <div className="o-tableize__cell u-text-right u-pb-">
            <Money automationId="text:paymentGiftCardsAmount">{paymentGiftCards}</Money>
          </div>
        </div>
      </div>
    </div>
  </ReportBox>
);
PaymentMethods.propTypes = {
  paymentPosCard: PropTypes.number.isRequired,
  paymentSquireCard: PropTypes.number.isRequired,
  paymentCash: PropTypes.number.isRequired,
  paymentGiftCards: PropTypes.number.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
};
PaymentMethods.defaultProps = {};

export default PaymentMethods;
